import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { labelQuePrintPackingSlipStart } from '../../../../../store/label-que/label-que.actions';
import { messages } from './messages';

export const FulfillmentProcessingHeaderActions = ({ batchId, className = '', isProcessing = false }) => {
  const dispatch = useDispatch();
  const onPrintPackingSlips = useCallback(() => {
    dispatch(labelQuePrintPackingSlipStart(batchId));
  }, [dispatch, batchId]);
  return (
    <div className={className}>
      <Button disabled={isProcessing} onClick={onPrintPackingSlips} theme='tertiary'>
        <FormattedMessage {...messages.printPackingSlips} />
      </Button>
    </div>
  );
};

FulfillmentProcessingHeaderActions.propTypes = {
  batchId: PropTypes.string.isRequired,
  isProcessing: PropTypes.bool,
  className: PropTypes.string,
};
